import PropTypes from 'prop-types';
import axios from 'axios';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import httpStatus from 'http-status/lib';
import { MESSAGES } from './messages';

export const AxiosErrorHandler = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    /**
     * レスポンスがthenまたはcatchされる前に実行する処理
     * ここに記載した共通のエラーハンドリング以外で必要な処理があればリクエスト実行元のtry-catchで個別に実装する
     */
    axios.interceptors.response.use(
      // responseのステータスコードが2xxの場合
      (response) => response,
      // ステータスコードが2xx以外の場合
      (error) => {
        switch (error.response?.status) {
          case httpStatus.BAD_REQUEST:
            enqueueSnackbar(MESSAGES.SAVE_FAILED, { variant: 'error' });
            break;
          case httpStatus.UNAUTHORIZED:
            error.loginFailed = MESSAGES.LOGIN_FAILED;
            navigate('/login', { replace: true });
            break;
          case httpStatus.FORBIDDEN:
            error.loginFailed = MESSAGES.LOGIN_FORBIDDEN;
            navigate('/login', { replace: true });
            break;
          case httpStatus.NOT_FOUND:
            error.loginFailed = MESSAGES.USER_NOT_FOUND;
            if (window.location.pathname !== '/login') {
              navigate('/notfound');
            }
            break;
          case httpStatus.CONFLICT:
            error.templateConflict = MESSAGES.TEMPLATE_CONFLICT;
            break;
          default:
            navigate('/internalServerError');
            break;
        }
        return Promise.reject(error);
      },
    );
  }, []);
  return <>{children}</>;
};

AxiosErrorHandler.propTypes = {
  children: PropTypes.object,
};
